import { Part } from "../playerConfiguration/Part";
import { ScenarioElement } from "../playerConfiguration/ScenarioElement";

export class PastOrCurrentPart extends Part {
  constructor(
    id: number,
    size: number,
    public scenarioElement: ScenarioElement,
  ) {
    super(id, size);
  }
}
